import { get } from "lodash";
import { cartoTileRe } from "../../carto-node/models/visualization";

export const getLegendData = (panel) => {
  if (panel.layerServiceInfo) {
    const url  = panel.layerServiceInfo.url;
    if (url.match(cartoTileRe)) {
      const id = cartoTileRe.exec(url)[1].replaceAll('_', '-');
      const base_url = url.split('/api/v1/map/named')[0];
      return {
        type: 'LayerLegend',
        id: panel.id,
        title: panel.name,
        url: `${base_url}/api/v3/viz/${id}/viz`,
      }
    }
    return {
      type: 'ImageLegend',
      id: panel.id,
      title: panel.name,
      url: panel.legend,
    }
  } else if (get(panel, "permission.owner.base_url")) {
    return {
      type: 'LayerLegend',
      id: panel.id,
      title: panel.name,
      url: `${get(panel, "permission.owner.base_url")}/api/v3/viz/${panel.id}/viz`,
    }
  } else {
    return {};
  }
};